/// <amd-module name="TFS/Organization/TakeOver/Components/OrganizationTakeOverComponent" />
import * as React from "react";
import * as ReactDOM from "react-dom";
import { Button } from "VSSUI/Button";
import { Dialog } from "VSSUI/Dialog";
import { ObservableValue } from "VSS/Core/Observable";
import { readJsonScript } from "VSS/Platform/Util/Serialization";
import { TextField, TextFieldWidth } from "VSSUI/TextField";
import { wait } from "VSS/Core/Util/Promise";
import * as OrganizationTakeOverResources from "TFS/Organization/TakeOver/Resources";

export interface IOrganizationTakeOverComponentState
{
    canClaimOwnership: boolean;
    ownershipClaimed: boolean;
    requestFailed: boolean;
    message: ObservableValue<string>;
}

interface IOrganizationTakeOverData
{
    organizationTakeOverEndPoint: string;
    organizationSettingsEndPoint: string;
    userSessionToken: string;
    newOwnerId: string;
}

export class OrganizationTakeOverComponent extends React.Component<{}, IOrganizationTakeOverComponentState> 
{
    private actionData: IOrganizationTakeOverData | null;

    public constructor(props: {}) 
    {
        super(props);

        const dataDictionary = readJsonScript<{ [key: string]: any }>("action-data");
        this.actionData = dataDictionary && dataDictionary["OrganizationTakeOverData"];
        this.state = { canClaimOwnership: false, ownershipClaimed: false, requestFailed: false, message: new ObservableValue<string>("") };
    }

    public render() 
    {
        if (!this.actionData) 
        {
            return;
        }

        return (
            <>
                {this.state.ownershipClaimed ?  (
                        <Button
                            disabled={true}>
                            {OrganizationTakeOverResources.CancelButtonText}
                        </Button>
                    ) : (
                        <Button
                            primary={true}
                            onClick={() => { this.setState({ canClaimOwnership: true }); }}> 
                            {OrganizationTakeOverResources.ClaimOwnershipButtonText}
                        </Button>
                )}

                {this.state.canClaimOwnership ? (
                    <Dialog
                        calloutContentClassName="claim-ownership-feedback-dialog"
                        footerButtonProps={[
                            {
                                onClick: () => { this.closeDialog(false); },
                                text: OrganizationTakeOverResources.CancelButtonText
                            },
                            {
                                primary: true,
                                onClick: () => 
                                { 
                                    this.closeDialog(true);
                                },
                                text: OrganizationTakeOverResources.ClaimOwnershipButtonText
                            }
                        ]}
                        lightDismiss={false}
                        onDismiss={() => { this.closeDialog(false);}}
                        titleProps={{ text: OrganizationTakeOverResources.ChangeOwnerDialogTitle }}
                    >
                        <span className="takeover-dialog-message">{OrganizationTakeOverResources.ChangeOwnerDialogMessage}</span>
                        <TextField
                            placeholder={OrganizationTakeOverResources.ReasonForOwnerChangePlaceholder}
                            multiline
                            rows={4}
                            width={TextFieldWidth.auto}
                            value={this.state.message}
                            onChange={(e, newValue) => (this.state.message.value = newValue)}
                            maxLength={256}
                        />
                        <span className="takeover-info-message">{OrganizationTakeOverResources.ChangeOwnerWarningText}</span>
                        {
                            this.state.requestFailed ? (<span className="takeover-error-message">{OrganizationTakeOverResources.RequestFailed}</span>) : null
                        }
                    </Dialog>
                ) : null}
            </>
        );
    }

    private closeDialog(ownershipClaimed: boolean) 
    {
        this.setState({canClaimOwnership: false, requestFailed: false});

        if (ownershipClaimed) 
        {
            if (this.actionData) 
            {
                var reason = this.state.message.value;
                reason = reason ? reason : "Not included";
                var newOwner = this.actionData.newOwnerId;
                var endPoint = this.actionData.organizationTakeOverEndPoint;
                var userSessionToken = this.actionData.userSessionToken;

                fetch( endPoint + "?newOwner=" + newOwner,
                {
                    method: 'post',
                    body: JSON.stringify(reason),
                    headers: {
                                'Accept': 'application/json; api-version=5.0-preview.1',
                                'Content-Type': 'application/json; charset=utf-8; api-version=5.0-preview.1',
                                'Authorization': 'Bearer ' + userSessionToken
                             },
                })
                .then( (response) => 
                {
                    if (response.status == 200)
                    {
                        this.setState({ canClaimOwnership: false, ownershipClaimed: true, requestFailed: false});
                        this.redirectToOrganizationSettingsPage(this.state.ownershipClaimed);
                    }
                    else
                    {
                        this.setState({canClaimOwnership: true, ownershipClaimed: false, requestFailed: true});
                    }
                })
                .catch((error) => 
                {
                    console.error(error.message);
                    this.setState({canClaimOwnership: true, ownershipClaimed: false, requestFailed: true});
                });
            }
        }
    }

    private async redirectToOrganizationSettingsPage(ownershipClaimed: boolean)
    {
        // fetch the page until it returns 200 instead of 401 (unauthorized) or 30 seconds have passed

        if (this.actionData && ownershipClaimed)
        {
            var orgSettings = this.actionData.organizationSettingsEndPoint;

            var i = 0;
            var retry = true;
            var progressPollInterval = 1000;

            while (retry && i++ < 30)
            {
                await fetch( orgSettings)
                .then( (response) => 
                {
                    if (response.status == 200)
                    {
                        window.location.href = orgSettings;
                    }

                    retry = (response.status == 401);
                })
                .catch((error) => 
                {
                    console.error("Error " + error);
                    retry =  false;
                });

                if (retry == true)
                {
                    await wait(progressPollInterval);
                }
            }
        }
    }
}

document.addEventListener("DOMContentLoaded", () => {
    ReactDOM.render(<OrganizationTakeOverComponent/>, document.getElementById("primary-action"));
});
